import React from 'react'
import Page, {
  DescriptionText,
  StyledFormContainer,
} from 'Event/template/Lefty/Login/Page'
import {useGuestVariables} from 'Event'
import {TitleText} from 'Event/template/Lefty/Login/Title'
import Configurable from 'organization/Event/Configurable'
import OfflineContentConfig from 'Event/template/Lefty/EventOfflinePage/OfflineContentConfig'
import {OfflinePageProps} from 'Event/JoinArea/OfflinePage'
import {useLeftyTemplate} from 'Event/template/Lefty'

export default function EventOfflinePage(props: OfflinePageProps) {
  const v = useGuestVariables()
  const {linkColor, linkUnderline} = useLeftyTemplate()

  return (
    <Page isPreview={props.isPreview || false}>
      <Configurable
        aria-label="event offline content config"
        dataTestId="event offline config"
      >
        <OfflineContentConfig />
        <StyledFormContainer>
          <OfflineTitle>{v(props.title)}</OfflineTitle>
          <DescriptionText linkColor={linkColor} linkUnderline={linkUnderline}>
            <div dangerouslySetInnerHTML={{__html: v(props.description)}} />
          </DescriptionText>
        </StyledFormContainer>
      </Configurable>
    </Page>
  )
}

function OfflineTitle(props: {children: string}) {
  const {textColor, offlinePage, login} = useLeftyTemplate()

  if (!props.children) {
    return null
  }

  return (
    <TitleText
      textColor={textColor}
      titleTextColor={offlinePage.titleTextColor ?? login.welcome.color}
      fontSize={offlinePage.titleFontSize ?? login.welcome.fontSize}
    >
      {props.children}
    </TitleText>
  )
}
